module.exports = __webpack_public_path__ + "img/NL.f3413c23.png";